import { Injectable } from '@angular/core';
import { ModulePermissionsDto } from '@core/dtos/profile.dto';
import {
  ModulePermission,
  PermissionId,
} from '@core/interfaces/entities/profile.interface';

/**
 * Mapper para convertir los permisos de módulos de la API
 * al DTO de ModulePermissions utilizado en el Cliente.
 */
@Injectable({ providedIn: 'root' })
export class ModulePermissionsMapper {
  /**
   * Mapea un array de 'ModulePermission' que proviene de la API
   * a un 'ModulePermissionsDto' para ser usado en el Cliente.
   *
   * @param modulePermissions El array de 'ModulePermission' a mapear.
   * @returns Un 'ModulePermissionsDto' listo para ser usado en el Cliente.
   */
  mapFrom(modulePermissions: ModulePermission[]): ModulePermissionsDto {
    if (!modulePermissions || modulePermissions.length === 0) {
      return {};
    }

    return modulePermissions.reduce(
      (permissions: ModulePermissionsDto, modulePermission) => {
        const permissionMap: Record<PermissionId, boolean> =
          modulePermission.permissions.reduce((map, permission) => {
            map[permission.permission_id] = permission.allow;
            return map;
          }, {} as Record<PermissionId, boolean>);

        permissions[modulePermission.module] = {
          moduleId: modulePermission.module_id,
          title: modulePermission.title,
          permissions: {
            Create: permissionMap[PermissionId.Create] ?? false,
            Read: permissionMap[PermissionId.Read] ?? false,
            Update: permissionMap[PermissionId.Update] ?? false,
            Delete: permissionMap[PermissionId.Delete] ?? false,
          },
        };
        return permissions;
      },
      {}
    );
  }
}
